import { Medium, SemiBold } from "../../apps/styles/common-style";

export const styles = {
    dialog: {
        textAlign: 'left' as const,
        padding: '0',
    },
    headerSection: {
        display: 'flex',
        alignItems: 'flex-start',
        padding: '32px 24px 10px 24px',
        gap: '8px',
    },
    header: {
        color: '#2d2d39',
        fontFamily: SemiBold,
        fontSize: '22px',
        lineHeight: '32px',
        padding: '0',
        margin: '0',
        flex: 1,
        minWidth: 0,
        wordWrap: 'break-word' as const,
        overflowWrap: 'break-word' as const,
    },
    content: {
        color: '#757588',
        fontFamily: Medium,
        fontSize: '16px',
        padding: '0 24px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'left' as const,
    },
    belowBlock: {
    },
    buttonDivider: {
        borderTop: '1px solid #e0e0e0',
        margin: '14px 0 0 0',
    },
    buttonSection: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '24px',
        gap: '16px',
    },
    checkboxBlock: {
        textAlign: 'left' as const,
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        outline: 'none',
        gap: '8px',
        minHeight: '44px',
    },
    dontShowCheckbox: {
        height: '18px',
        width: '18px',
        margin: '0',
        cursor: 'pointer',
        appearance: 'auto' as any,
        accentColor: '#196ecf',
        flexShrink: 0,
    },
    modalPopupText: {
        color: '#757588',
        fontFamily: Medium,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '24px',
        margin: '0',
    },
    buttonsBlock: {
        marginTop: '0'
    },
    noThanksBtn: {
        boxSizing: 'border-box' as const,
        height: '40px',
        width: '202px',
        border: '1px solid #196ecf',
        borderRadius: '2px',
        color: '#196ecf',
        fontFamily: SemiBold,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '3px',
        textAlign: 'center' as const,
        backgroundColor: '#ffffff',
        cursor: 'pointer',
    },
    continueBtn: {
        boxSizing: 'border-box' as const,
        height: '40px',
        width: '112px',
        color: '#ffffff',
        fontFamily: SemiBold,
        fontSize: '16px',
        letterSpacing: '0.2px',
        lineHeight: '22px',
        textAlign: 'center' as const,
        borderRadius: '2px',
        backgroundColor: '#196ecf',
        border: '1px solid #196ecf',
        cursor: 'pointer',
    },
    box: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        // boxShadow: 24,
        p: 0,
        outline: 0,
        width: 550,
        maxWidth: '80vw',
    },
    taxIdbox: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        // boxShadow: 24,
        p: 0,
        outline: 0,
        width: 510,
        maxWidth: '80vw',
        height: 'auto'
    },
    taxErrorIdbox: {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        // border: '2px solid #000',
        // boxShadow: 24,
        p: 0,
        outline: 0,
        width: 510,
        maxWidth: '80vw',
        height: 'auto'
    },
    iconContainer: {
        boxSizing: 'border-box',
        height: '64px',
        width: '64px',
       // border: '1px solid #bb880a',
        borderRadius: '48px',
        backgroundColor: '#fffcd9',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '24px',

        warningIcon: {
            marginLeft: '14px',
            marginTop: '12.25px'
        }
    },

    cancelButton: {
        boxSizing: 'border-box',
        height: '40px',
        width: '98px',
        border: '1px solid #196ecf',
        borderRadius: '2px',
        color: '#196ecf',
        fontFamily: 'UHCSans-SemiBold,Helvetica,Arial,Verdana,Tahoma,sans-serif',
        fontSize: '16px',
        letterSpacing: '.2px',
        lineHeight: '22px',
        textAlign: 'center',
        marginRight: '11.5px',
        backgroundColor: 'transparent',
        cursor: 'pointer',
    },
    continueButton: {
        boxSizing: 'border-box',
        height: '40px',
        width: '191px',
        color: '#fff',
        fontFamily: 'UHCSans-SemiBold,Helvetica,Arial,Verdana,Tahoma,sans-serif',
        fontSize: '16px',
        letterSpacing: '.2px',
        lineHeight: '22px',
        textAlign: 'center',
        borderRadius: '2px',
        backgroundColor: '#196ecf',
        border: '1px solid #196ecf',
        marginLeft: '11.5 px',
        cursor: 'pointer'
    },
    cancelButtonHovered: {
        backgroundColor: '#003da1',
        color: '#ffffff'
    },
    deleteButtonHovered: {
        backgroundColor: '#003da1',
        color: '#ffffff'
    },
    crossIcon: {
        padding: '0',
        color: '#2d2d39',
        fontWeight: '900',
        fontSize: 'larger',
        cursor: 'pointer',
        lineHeight: '1',
        flexShrink: 0,
    },
    crossIconTopRight: {
        position: 'absolute' as const,
        top: '32px',
        right: '24px',
        padding: '0',
        color: '#2d2d39',
        fontWeight: '900',
        fontSize: 'larger',
        cursor: 'pointer',
        lineHeight: '1',
        zIndex: 2,
    },
    taxIdDialog: {
        width: '494px',
        paddingBottom:'10px'
    },
    taxIdDialogContent: {
        padding: '16px'
    },
     taxIdHeader: {
        fontFamily: `${Medium}`,
        fontWeight: '600',
        fontSize: '16px',
        lineHeight: '100%',
        letterSpacing: '0%;',
        marginBottom: '16px'
    },
    taxIdSubHeader: {
        fontFamily: `${Medium}`,
        fontWeight: '500',
        fontSize: '16px',
        lineHeight: '100%',
        letterSpacing: '0%;',
        color:'#757588'
    },
    textContainer: {
        width: '98% !important',
        height: '100px', // Reduced height
        border: '1px solid #ccc',
        padding: '10px',
        color: '#757588',
        fontSize: '16px',
        fontFamily: `${Medium}`,
    },
    taxHeaderContent : {
        width:'494px',
        marginBottom: '16px',
        display:'flex',
        height:'80px'
    },
    taxIdErrorCard : {
        width:'472px',
        height: '62px',
        marginBottom: '10px'
    },
    taxIdTextArea: {
        border: '1px solid #ccc',
        padding: '8px',
        width:'462px',
        height: '200px',
        whiteSpace: 'pre-wrap', // Ensures line breaks are preserved
        overflow: 'auto',
        margin: '8px'
    },
    divider: {
        borderBottom: '1px solid #ccc',
        margin: '16px 0',
    },
    taxIdButton: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    taxCancelBtn: {
    backgroundColor: 'transparent',
    border: 'none',
    fontWeight: 'bold',
    margin: '0 16px'
    }

}